import { IStyle } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IJobListStyles {
  root?: IStyle;
  listView?: IStyle;
  listViewWrap?: IStyle;
  cardView?: IStyle;
  calloutContents?: IStyle;
  calloutHeader?: IStyle;
  calloutBody?: IStyle;
}

export interface IJobListClassNames {
  root: string;
  listView: string;
  listViewWrap: string;
  cardView: string;
  calloutContents: string;
  calloutHeader: string;
  calloutBody: string;
}

export const jobListStylesDefault = (theme: IH2OTheme): Partial<IJobListStyles> => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
  },
  listView: {
    flex: 1,
    padding: 24,
    paddingRight: 18,
    backgroundColor: theme.palette?.white,
  },
  listViewWrap: {
    overflow: 'auto',
    height: '100%',
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
  calloutHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
    span: {
      fontWeight: FontWeights.semiBold,
    },
  },
});
